<template>
  <div>
    <fzg-join-detail-pc v-if="isPc()"></fzg-join-detail-pc>
    <fzg-join-detail-mobile v-else></fzg-join-detail-mobile>
  </div>
</template>

<script>

import util from '@/assets/js/util.js'
import FzgJoinDetailPc from './FzgJoinDetailPc.vue'
import FzgJoinDetailMobile from './FzgJoinDetailMobile.vue'

export default {

  components: {
    FzgJoinDetailPc,
    FzgJoinDetailMobile
  },

  methods: {
    isPc() {
      return util.isPc()
    }
  }

}
</script>



// WEBPACK FOOTER //
// FzgJoinDetail.vue?fde39ed6